<template>
  <div class="container">
    <template v-if="pesertas.length === 0">
      <v-alert color="info" text>
        <v-row align="center">
          <v-col class="grow">
            Belum ada peserta yang ditambahkan, silakan tekan tombol
            <v-icon color="success">mdi-plus-circle</v-icon> pada sebelah kanan untuk menambahkan peserta
          </v-col>
          <v-col class="shrink">
            <v-btn color="success" icon large @click="onAddPeserta"><v-icon large>mdi-plus-circle</v-icon></v-btn>
          </v-col>
        </v-row>
      </v-alert>
    </template>
    <template v-else>
      <v-form lazy-validation v-model="valid" ref="form">
        <v-row class="mt-2" v-for="(peserta, p) in pesertas" :key="p">
          <v-col cols="12" md="4" sm="12">
            <validation-provider mode="passive" :name="`Peserta ke ${p + 1}`" :rules="'required'" v-slot="{ errors }">
              <span>Nama Guru</span>
              <v-select
                outlined
                v-model="pesertas[p]['ptk_id']"
                :items="detail.pesertas"
                :itemDisabled="checkDisabled"
                item-value="ptk_id"
                item-text="nama"
                placeholder="Pilih Peserta"
                :rules="[(v) => !!v || 'Peserta wajib dipilih']"
                :error-messages="errors"
              >
                <template v-slot:selection="{ item }">
                  <div>
                    <div class="blue--text">{{ item.nama }}</div>
                    <div class="black--text font-weight-bold">No. UKG: {{ item.ptk_id }}</div>
                  </div>
                </template>
              </v-select>
            </validation-provider>
          </v-col>
          <v-col cols="12" md="3" sm="12">
            <span>Skor Pre Test</span>
            <validation-provider
              mode="passive"
              :name="`Nilai pre test ke ${p + 1}`"
              :rules="'required'"
              v-slot="{ errors }"
            >
              <v-text-field
                v-model="pesertas[p]['n_pretest']"
                single-line
                label="Skor Pre Test"
                hint="Rentang nilai 1-100"
                persistent-hint
                outlined
                :rules="[
                  (v) => {
                    if (!v) return true;
                    if (!isNaN(parseFloat(v)) && v >= 1 && v <= 100) return true;
                    return 'Nilai harus antara 1 - 100';
                  },
                  (v) => !!v || 'Skor pre test wajib diisi',
                ]"
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
          </v-col>
          <v-col cols="12" md="3" sm="12">
            <span>Skor Post Test</span>
            <validation-provider
              mode="passive"
              :name="`Nilai post test ke ${p + 1}`"
              :rules="'required'"
              v-slot="{ errors }"
            >
              <v-text-field
                v-model="pesertas[p]['n_posttest']"
                single-line
                label="Skor Pre Test"
                hint="Rentang nilai 1-100"
                persistent-hint
                outlined
                :rules="[
                  (v) => {
                    if (!v) return true;
                    if (!isNaN(parseFloat(v)) && v >= 1 && v <= 100) return true;
                    return 'Nilai harus antara 1 - 100';
                  },
                  (v) => !!v || 'Skor post test wajib diisi',
                ]"
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
          </v-col>
          <v-col cols="12" md="2" sm="12">
            <div>
              <div v-if="$vuetify.breakpoint.mdAndUp" style="height: 30px" />
              <v-btn icon><v-icon color="red" large @click="onDeletePeserta(p)">mdi-close-circle</v-icon></v-btn>
              <v-btn v-if="p + 1 === pesertas.length" class="mx-md-2" icon @click="onAddPeserta">
                <v-icon color="success" large>mdi-plus-circle</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </template>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
export default {
  components: { ValidationProvider },
  props: {
    detail: {
      type: Object,
      default: null,
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      pesertas: [],
      valid: true,
    };
  },

  computed: {},

  methods: {
    onAddPeserta() {
      if (this.pesertas.length >= 25) {
        this.$error('Jumlah peserta sudah melebihi maksimal (25 peserta)');
        return;
      }

      let isValid = false;
      if (this.pesertas.length === 0) {
        isValid = true;
      } else {
        isValid = this.$refs.form.validate();
      }
      if (isValid) this.pesertas.push({ ptk_id: '', n_pretest: '', n_posttest: '' });
    },

    onDeletePeserta(index) {
      this.$confirm('Anda yakin ingin hapus peserta berikut ?', 'Hapus Peserta', {
        tipe: 'warning',
        data: [],
      }).then(() => {
        this.pesertas.splice(index, 1);
      });
    },

    checkDisabled(item) {
      return this.pesertas.findIndex((key) => key.ptk_id === item.ptk_id) > -1;
    },

    initForm(value) {
      this.pesertas = value || [];
    },
  },

  watch: {
    pesertas: {
      handler: function(val) {
        this.$emit('input', val);
      },
      deep: true,
    },
    value: 'initForm',
  },
};
</script>
